<template>
    <div class="modal fade" id="citySelectorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">انتخاب شهر</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="content-section default">
                                <form @submit.prevent="selectedCityOnSubmit" class="form-account">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12">
                                            <div class="form-account-title">نام استان</div>
                                            <div class="form-account-row">
                                                <select id="selectedProvinceId" @change="getCities" v-model="selectedProvinceId" class="input-field text-right">
                                                    <option value="">استان را انتخاب کنید...</option>
                                                    <option v-for="province in provinces" :value="province.Value">{{ province.Text }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12">
                                            <div class="form-account-title">نام شهر</div>
                                            <div class="form-account-row">
                                                <select id="selectedCityId" v-model="selectedCityId" v-validate="{ required: true}" data-vv-as="نام شهر" class="input-field text-right">
                                                    <option value="">شهر را انتخاب کنید...</option>
                                                    <option v-for="city in cities" :value="city.Value">{{ city.Text }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 text-center">
                                        <button   type="submit" class="btn btn-default btn-lg">ذخیره</button>
                                        <button data-dismiss="modal" class="btn btn-default btn-lg">انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    import { citySelectorEventBus } from "../../../eventBus/eventBus"
    export default {
        data() {
            return {
                provinces: [],
                cities: [],
                selectedCityId: '',
                selectedProvinceId: '',
            }
        },
        beforeMount: function () {
            httpPromise(this, '/v1/BasicDefinitions/Provinces/Read', 'get', '',
                response => {
                    toastr.remove();
                    this.provinces = response.data.Value;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                });
            $(function () {
                $('#citySelectorModal').on("hidden.bs.modal", function (event) {
                    $('body').addClass('modal-open');
                });
            });
        },
        methods: {
            getCities() {
                httpPromise(this, '/v1/BasicDefinitions/Cities/ReadByProvince' , 'get', { ProvinceId: this.selectedProvinceId},
                    response => {
                        toastr.remove();
                        this.cities = response.data.Value;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                    });
            },

            selectedCityOnSubmit: function () {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        var cityId = this.selectedCityId
                        $(function () {
                            var cityFullName = $('#selectedProvinceId option:selected').html() + ' - ' + $('#selectedCityId option:selected').html();
                            citySelectorEventBus.$emit('cityOnSelected', { cityId: cityId, cityFullName: cityFullName });
                            $('#citySelectorModal').modal('hide');
                        });
                    }
                });

            },
        }
    }
</script>

<style scoped>
    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: contents;
    }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }
</style>